import { render, staticRenderFns } from "./TwScoreBadge.vue?vue&type=template&id=0020fa22"
import script from "./TwScoreBadge.vue?vue&type=script&lang=js"
export * from "./TwScoreBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports